export default "/_next/static/fonts/07db1889cf0be5bf60a4353927d8c914.eot";